// angular import
import { Component } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Router, RouterModule } from '@angular/router'
import { FormControl, Validators } from '@angular/forms'

// project import
import { SharedModule } from 'src/app/demo/shared/shared.module'
import { BY_NAME_DIVIDER, CHECK_FOR_ROOM_URL, CHECK_FOR_SPECIFIED_PHONE_URL, CONFIRM_BOOKED_URL, GET_CODE_ROOM_URL, GET_DATA_BY_SESSION_URL, INIT_SESSION_URL, TEMP_ROOMS } from './confirm.consts'
import { SpecifyAfterInitType, SpecifyByPhoneType, ErrorType, InitSuccessType, GotSessionData, CodeLinkType, RoomType, States, Room } from './confirm.types'
import { validateName, validatePhone } from 'src/utils/validate'

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, SharedModule, RouterModule],
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss'],
})
export default class ConfirmComponent {
  // public props
  hide = true;
  bookedId = new FormControl("", [Validators.required, Validators.minLength(3)]);
  firstName = new FormControl("", [Validators.required, Validators.minLength(3)]);
  lastName = new FormControl("", [Validators.required, Validators.minLength(3)]);
  phone = new FormControl("", [Validators.required, Validators.pattern(/^\+?\d{5,15}$/)]);
  rooms:Array<Room> = []
  room:RoomType
  selectedRoomFlag:boolean = false
  confirmedRoom:any

  errors = {
    init: '',
    generate: '',
  }

  loading: Boolean = false
  codeLink: CodeLinkType = { code: '', link: '' }
  state: States = States.INITIAL
  prevState: States | null = null

  BookedId = ''
  FirstName = ''
  LastName = ''
  Phone = ''
  CheckIn = ''
  CheckOut = ''
  checked: boolean = true

  constructor(public router: Router) {}

  changeValue(value: Boolean) {
    this.checked = !value
  }

  getAppropriateBody() {
    switch (this.state) {
      case States.BOOKED_ID:
        return {
          bookedId: this.BookedId,
        };
      case States.SPECIFY_BY_ROOM:
      case States.SPECIFY_BY_ROOM_AFTER_FULL:
        const foundRoom = this.rooms.find(room => room._id === this.room)
        this.confirmedRoom = foundRoom

        return {
          bookingId: foundRoom.booking._id,
          roomId: foundRoom.room._id
        };
      case States.BY_NAME:
        return {
          fullName: `${this.FirstName}${BY_NAME_DIVIDER}${this.LastName}`,
        };
      case States.BY_PHONE:
      case States.SPECIFY_BY_PHONE:
        return {
          phone: this.Phone,
        };
      case States.BOOKED_ID_CONFIRM: {
        return {
          type: 'id'
        }
      }

      default:
        return JSON.stringify({})
    }
  }

  initSession(): Promise<InitSuccessType | ErrorType | SpecifyAfterInitType> {
    return new Promise<InitSuccessType | ErrorType>((resolve, reject) => {
      // console.log(`→ getAppropriateBody()`, this.getAppropriateBody());
      // reject({
      //   any: true,
      //   rooms: TEMP_ROOMS
      // })
      fetch(INIT_SESSION_URL, {
        method: 'POST',
        body: JSON.stringify(this.getAppropriateBody()),
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
        .then((data) => data.json())
        .then((data) => {
          if (data.message) {
            reject({
              ...data,
              message: data.message,
            });
          }

          if (data.any) {
            reject({
              ...data,
              any: true,
            });
          }

          resolve(data)
        })
        .catch((e) => {
          reject({
            notFound: true,
          })
        })
    })
  }

  getDataBySession() {
    return new Promise<GotSessionData>((resolve, reject) => {
      this.toResetGlobalErrors()

      fetch(GET_DATA_BY_SESSION_URL, {
        credentials: 'include',
      })
        .then((data) => data.json())
        .then((data) => {
          if (!data.any) resolve(data);

          if (data.any) {
            reject({
              ...data,
              any: true,
            });
          } else {
            reject({
              ...data,
              notInit: true,
            });
          }
        })
        .catch((e) => {
          reject({
            notInit: true,
          })
        })
    })
  }

  generateCodeRoom(): Promise<CodeLinkType> {
    return new Promise((resolve, reject) => {
      fetch(GET_CODE_ROOM_URL, {
        credentials: 'include',
      })
        .then((data) => data.json())
        .then((data) => {
          if (data.code) resolve(data)

          reject({
            ...data,
            notGenerated: true,
          })
        })
        .catch((e) => {
          reject({
            notGenerate: true,
          })
        })
    })
  }

  confirmBooked() {
    return new Promise((resolve, reject) => {
      fetch(CONFIRM_BOOKED_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(this.getAppropriateBody()),
        credentials: 'include',
      })
        .then((data) => data.json())
        .then((data) => {
          if (data.success) resolve(data)

          reject({
            ...data,
            notInit: true,
          })
        })
        .catch((e) => {
          reject({
            notInit: true,
          })
        })
    })
  }

  setBookedIdState(state: States) {
    this.state = state
  }

  back() {
    if (this.loading) return

    switch (this.state) {
      case States.BOOKED_ID:
      case States.BY_NAME:
      case States.BY_PHONE:
        this.state = States.INITIAL;
        this.toInitialState();
        break;
      case States.SPECIFY_BY_PHONE:
      case States.SPECIFY_BY_ROOM:
      case States.SPECIFY_BY_ROOM_AFTER_FULL:
        this.state = this.prevState || States.INITIAL
        break
      case States.BOOKED_ID_CONFIRM:
        if ([States.SPECIFY_BY_ROOM, States.SPECIFY_BY_PHONE, States.SPECIFY_BY_ROOM_AFTER_FULL ].includes(this.prevState)) {
          return
        }

        this.state = this.prevState || States.INITIAL
        this.selectedRoomFlag = false

        switch(this.prevState) {
          case States.SPECIFY_BY_ROOM:
            this.prevState = States.BY_PHONE
            break
          case States.SPECIFY_BY_PHONE:
            this.prevState = States.BOOKED_ID
            break
          case States.SPECIFY_BY_ROOM_AFTER_FULL:
            this.prevState = States.BY_NAME
            break
        }
        break
      default:
        console.log('ERROR')
    }
  }

  setAppropriateError(e?:Error) {
    switch (this.state) {
      case States.BOOKED_ID:
        return this.bookedId.setErrors({ incorrect: true });
      case States.BY_NAME:
        this.firstName.setErrors({ incorrect: true });
        this.lastName.setErrors({ incorrect: true });
        return;
      case States.BY_PHONE:
        return this.phone.setErrors({ incorrect: true });
      case States.SPECIFY_BY_PHONE:
        return this.phone.setErrors({ 'incorrect-specify': true });
      case States.SPECIFY_BY_ROOM:
      case States.SPECIFY_BY_ROOM_AFTER_FULL:
        this.errors.generate = e.message
        break
      default:
        return ''
    }
  }

  formatDate (date:any) {
    const formatDateLocale = window.location.pathname.includes('/de') ? "de-DE" : "ru-RU"

    return date
      .toLocaleString(formatDateLocale, { dateStyle: 'short' })
      .replace(/\//g, '.')
      .replace(/\d+/g, (r:string) => r.padStart(2, '0'))
  }

  zzz():Promise<SpecifyByPhoneType> {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // resolve
        resolve({
          verified: false
        })
      }, 1000)
    })
  }

  checkForSpecifiedRoom() {
    this.loading = true;
    fetch(CHECK_FOR_ROOM_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.getAppropriateBody()),
      credentials: "include",
    })
      .then(data => data.json())
      .then(data => {
        if (data.verified) {
          this.getDataBySession()
            .then((data: GotSessionData) => this.fillData(data))
            .catch((e) => this.catcherErrors(e))
            .finally(() => { this.loading = false })
        } else {
          this.setAppropriateError()
          this.loading = false;
        }
      })
      .catch(e => {
        console.error(`→ Unexpected Error`, e);
        this.setAppropriateError(e)
        this.loading = false;
      })
  }

  checkForSpecifiedPhone() {
    this.loading = true;
    fetch(CHECK_FOR_SPECIFIED_PHONE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.getAppropriateBody()),
      credentials: "include",
    })
      .then(data => data.json())
      .then(data => {
        if (data.verified) {
          this.phone.reset();
          this.getDataBySession()
            .then((data: GotSessionData) => this.fillData(data))
            .catch((e) => this.catcherErrors(e))
            .finally(() => { this.loading = false })
        } else {
          this.setAppropriateError()
          this.loading = false;
        }
      })
      .catch(e => {
        console.error(`→ Unexpected Error`, e);
        this.setAppropriateError(e)
        this.loading = false;
      })
  }

  fillData(data:GotSessionData) {
    const { bookedId, dateStart, dateEnd, name, phone, surname } = data

    const checkIn = new Date(dateStart)
    const checkOut = new Date(dateEnd)

    this.Phone = phone ? (phone.startsWith('+') ? phone : `+${phone}`) : ''
    this.LastName = surname || ''
    this.FirstName = name || ''
    this.BookedId = bookedId
    this.CheckIn = dateStart ? this.formatDate(checkIn) : ''
    this.CheckOut = dateEnd ? this.formatDate(checkOut) : ''
    this.prevState = this.state
    this.state = States.BOOKED_ID_CONFIRM

    this.errors.init = ''
}

  catcherErrors(e:any) {
    if (e.notFound) {
      this.setAppropriateError();
      this.errors.init = "";
    } else if (e.notInit) {
      this.errors.init = "Error while init session";
    } else if (e.any) {
      this.prevState = this.state;
      if (this.state === States.BOOKED_ID) {
        this.state = States.SPECIFY_BY_PHONE;
      } else if (this.state === States.BY_PHONE || this.state === States.BY_NAME) {
        this.rooms = e.rooms
        this.room = this.rooms[0]._id
        this.state = this.state === States.BY_PHONE 
          ? States.SPECIFY_BY_ROOM
          : States.SPECIFY_BY_ROOM_AFTER_FULL;
      }
    } else if (e.message) {
      if (e.message.includes('Rooms were not found')) {
        if (this.state === States.BOOKED_ID) {
          this.errors.init = e.message;
        } else {
          this.setAppropriateError();
        }
      } else {
        this.errors.init = e.message;
      }
    } else {
      console.error(`→ Unexpected Error`, e);
    }
  }

  checkForBooked() {
    this.loading = true
    this.initSession()
      .then(() => this.getDataBySession())
      .then((data: GotSessionData) => this.fillData(data))
      .catch((e) => this.catcherErrors(e))
      .finally(() => { this.loading = false });
  }

  toConfirmBooked() {
    if (this.errors.generate || this.errors.init) return
    if (this.loading) return
    if (!this.checked) return

    this.loading = true
    this.generateCodeRoom()
      .then((data) => {
        this.codeLink = {
          code: data.code,
          link: data.link.startsWith('https://')
            ? data.link
            : `https://${data.link}`,
        }
        return this.confirmBooked()
      })
      .then(() => {
        this.state = States.BOOKED_CONFIRMED
      })
      .catch((e) => {
        if (e.notGenerated) {
          this.errors.init = ''
          this.errors.generate = 'Error during code generation'
        } else if (e.notInit) {
          this.errors.generate = ''
          this.errors.init = 'Error checking for an active session'
        } else {
          console.error(`→ Unexpected Error`, e)
        }
      })
      .finally(() => {
        this.loading = false
      })
  }

  toSendMessage() { console.log('→ send') }

  toEmptyValues() {
    this.BookedId = ''
    this.FirstName = ''
    this.LastName = ''
    this.Phone = ''
    this.CheckIn = ''
    this.CheckOut = ''
  }

  toResetState() {
    this.state = States.INITIAL
    this.prevState = null
  }

  toResetErrors() {
    this.phone.reset()
    this.bookedId.reset()
    this.firstName.reset()
    this.lastName.reset()
  }

  toResetGlobalErrors() {
    this.errors.init = ''
    this.errors.generate = ''
  }

  toInitialState() {
    this.toEmptyValues()
    this.toResetState()
    this.toResetErrors()
    this.toResetGlobalErrors()
  }

  clickToChooseRoom() {
    this.selectedRoomFlag = true
  }

  onValidateNumber (e:Event) {
    this.Phone = validatePhone(this.Phone)
  }

  onValidateNames (e:Event, field:string) {
    if (field === 'firstName') {
      this.FirstName = validateName(this.FirstName)
    }

    if (field === 'lastName') {
      this.LastName = validateName(this.LastName)
    }
  }
}
